import { useState } from 'react';

export default function useSearchTerm() {
  const [searchTerm, setSearchTerm] = useState('');
  const handleFilterChange = (value) => {
    setSearchTerm(value);
  };
  return { searchTerm, handleFilterChange };
}
